import React from 'react';
import {CardContent} from "@mui/material";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import {Trans} from "react-i18next";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {CheckCircle} from "@mui/icons-material";

function AddressShowBox({address, withButton, onClick, selected, rightTopCornerBoxContent, showFirmData}) {
    return (
        <Card sx={{maxWidth: 400, margin: '20px'}}>
            {selected ? <Box
                sx={{position: 'absolute', right: 10, top: 10, zIndex: 10}}><CheckCircle color="primary" sx={{pl: 1}}/>
            </Box> : ''}
            {rightTopCornerBoxContent ? <Box
                sx={{position: 'absolute', right: 10, top: 10, zIndex: 10}}>{rightTopCornerBoxContent}
            </Box> : ''}
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {address.firstName} {address.lastName}
                </Typography>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    <strong><Trans i18nKey="addressForm.telNr"/>:</strong> {address.telNr}
                </Typography>
                <Grid container spacing={1} sx={{marginTop: 2}}>
                    {showFirmData && <>
                        <Grid xs={12}>
                            <Typography variant="body2">
                                <strong><Trans i18nKey="addressForm.firmName"/>:</strong> {address.firmName}
                            </Typography>
                        </Grid>
                        <Grid xs={12}>
                            <Typography variant="body2">
                                <strong><Trans i18nKey="addressForm.vatNr"/>:</strong> {address.vatNr}
                            </Typography>
                        </Grid>
                    </>}
                    <Grid xs={12}>
                        <Typography variant="body2">
                            <strong><Trans i18nKey="addressForm.addLine1"/>:</strong> {address.addressLine1}
                        </Typography>
                    </Grid>
                    {address.addressLine2 && (
                        <Grid xs={12}>
                            <Typography variant="body2">
                                <strong><Trans i18nKey="addressForm.addLine2"/>:</strong> {address.addressLine2}
                            </Typography>
                        </Grid>
                    )}
                    <Grid xs={6}>
                        <Typography variant="body2">
                            <strong><Trans i18nKey="addressForm.city"/>:</strong> {address.city}
                        </Typography>
                    </Grid>
                    <Grid xs={6}>
                        <Typography variant="body2">
                            <strong><Trans i18nKey="addressForm.zipCode"/>:</strong> {address.zipCode}
                        </Typography>
                    </Grid>
                    <Grid xs={12}>
                        <Typography variant="body2">
                            <strong><Trans i18nKey="addressForm.county"/>:</strong> {address.county}
                        </Typography>
                    </Grid>
                    <Grid xs={12}>
                        <Typography variant="body2">
                            <strong><Trans i18nKey="addressForm.country"/>:</strong> <Trans
                            i18nKey="addressForm.countryname"/>
                        </Typography>
                    </Grid>
                </Grid>
                {withButton && !selected ? <Box
                    sx={{
                        position: {xs: 'initial', md: 'absolute'},
                        right: 10,
                        top: 10,
                        zIndex: 10,
                        pt: {xs: 2, md: 0}
                    }}>
                    <Button variant={'contained'} onClick={onClick} color={'secondary'}>
                        <Trans i18nKey={'buttons.useThis'}/>
                    </Button>
                </Box> : ''}
            </CardContent>
        </Card>
    );
}

export default AddressShowBox;
